import * as React from 'react';
import './EmailConfirmationBanner.scss';
import { FormText } from 'reactstrap';
import AppButton from '../AppButton';

export interface EmailConfirmationBannerProps {
    email?: string | null;
    emailConfirmed?: boolean;
    message: string;
    resendButtonLabel: string;
    onResendEmail?: () => void;
}

const EmailConfirmationBanner: React.FC<EmailConfirmationBannerProps> = ({
    email,
    emailConfirmed = false,
    message,
    resendButtonLabel,
    onResendEmail,
}) => {
    const [confirmationEmailSent, setConfirmationEmailSent] = React.useState(false);

    if (!email || !onResendEmail || emailConfirmed) {
        return null;
    }

    return (
        <FormText color={emailConfirmed ? "success" : "muted"} className="emailConfirmationBanner">
            {message}
            &nbsp;
            {!confirmationEmailSent && (
                <AppButton
                    id={'user-resend-confirmation-email-button'}
                    className="resendConfirmationEmailButton"
                    color="link"
                    onClick={() => {
                        setConfirmationEmailSent(true);
                        onResendEmail();
                    }}
                >
                    {resendButtonLabel}
                </AppButton>
            )}
        </FormText>
    );
};

export default EmailConfirmationBanner;
